import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const CardChecklistDueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CardChecklistDue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"None"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checklists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"due"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"CardChecklistDue","document":CardChecklistDueDocument}} as const;
export type CardChecklistDueQueryVariables = Types.Exact<{
  parentId: Types.Scalars['ID'];
}>;


export type CardChecklistDueQuery = (
  { __typename: 'Query' }
  & { card?: Types.Maybe<(
    { __typename: 'Card' }
    & Pick<Types.Card, 'id'>
    & { checklists: Array<(
      { __typename: 'Checklist' }
      & Pick<Types.Checklist, 'id'>
    )> }
  )> }
);




/**
 * __useCardChecklistDueQuery__
 *
 * To run a query within a React component, call `useCardChecklistDueQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardChecklistDueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardChecklistDueQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useCardChecklistDueQuery(baseOptions: Apollo.QueryHookOptions<CardChecklistDueQuery, CardChecklistDueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardChecklistDueQuery, CardChecklistDueQueryVariables>(CardChecklistDueDocument, options);
      }
export function useCardChecklistDueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardChecklistDueQuery, CardChecklistDueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardChecklistDueQuery, CardChecklistDueQueryVariables>(CardChecklistDueDocument, options);
        }
export type CardChecklistDueQueryHookResult = ReturnType<typeof useCardChecklistDueQuery>;
export type CardChecklistDueLazyQueryHookResult = ReturnType<typeof useCardChecklistDueLazyQuery>;
export type CardChecklistDueQueryResult = Apollo.QueryResult<CardChecklistDueQuery, CardChecklistDueQueryVariables>;